export default theme => ({
  divider_bottom: {
    paddingBottom: 20,
  },
  button_container: {
    display: "flex",
    justifyContent: "center",
  },
  form__serverError: {
    color: theme.palette.secondary.main,
    margin: 20,
  },
});
